webpackJsonp([23],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/checklist/checklist.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] checklist.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3583a9f1", Component.options)
  } else {
    hotAPI.reload("data-v-3583a9f1", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checklist_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checklist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__checklist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].getChannel();

  next(function (response) {
    return response;
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  },
  update: function update(el, binding) {
    document.title = el.dataset.title;
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__checklist_vue___default.a);
  }
}).$mount('#privacy');

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.2rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div {\n  text-indent: 0.21rem;\n  margin: 0.01rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n  margin: 0.1rem 0rem;\n}\n#privacy div .sub-title {\n  font-weight: 500;\n  margin-top: 0.08rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("1. 个人基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称:")]), _vm._v(" "), _c('div', [_vm._v("电话号码")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集目的:")]), _vm._v(" "), _c('div', [_vm._v("账号注册、登录使用成者云旗下软件")]), _vm._v(" "), _c('div', [_vm._v("保障用户安全,找回密码等服务")]), _vm._v(" "), _c('div', [_vm._v("账号丢失找回凭证")]), _vm._v(" "), _c('div', [_vm._v("提供客服和售后提供咨询服务")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("登录注册时")]), _vm._v(" "), _c('div', [_vm._v("默认的用户昵称")]), _vm._v(" "), _c('div', [_vm._v("与客服和售后咨询服务")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况:")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称:")]), _vm._v(" "), _c('div', [_vm._v("邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集目的:")]), _vm._v(" "), _c('div', [_vm._v("可作为账号进行账号注册、登录、密码找回时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("账号注册、登录、密码找回时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况:")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("2. 网络身份标识信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称:")]), _vm._v(" "), _c('div', [_vm._v("账号及密码")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("创建账号")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("创建账号时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("昵称")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("完善账号信息；发布信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("会议开启或在通讯录进行展示")]), _vm._v(" "), _c('div', [_vm._v("生成文件的默认署名")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("头像")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("完善账号信息；发布信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("会议开启时，或在通讯录进行展示")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("第三方账号信息（头像、昵称）")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("第三方登录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("使用第三方账号进行登录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("3. 个人常用设备信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("设备品牌")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("设备型号")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("MAC地址")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("设备唯一识别码(OAID/IMEI/MEID/AndroidID/IDFA/OPENUDID/IDFV/出厂序列号/SIM卡IMSI)")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("屏幕分辨率")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("操作系统版本")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("网络类型")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("网络运营商类型")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("已安装应用列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("第三方登录与分享时,需要判断是否已经安装需要使用的第三方应用")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("第三方登录与分享")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("应用进程列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("应用崩溃数据")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App运行崩溃时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("每次崩溃时收集1次")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3583a9f1", module.exports)
  }
}

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(357);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("21248eec", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3583a9f1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checklist.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3583a9f1\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./checklist.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ })

},[256]);


// WEBPACK FOOTER //
// static/js/module/checklist.5a44b82767364e6ed775.js